import jwt from 'jsonwebtoken';

export function getDecodedToken(token: string): jwt.JwtPayload {
	const decodedToken = jwt.decode(token);
	if (typeof decodedToken !== 'object' || !decodedToken?.userID) {
		throw { details: 'Invalid token provided.' };
	}
	return decodedToken;
}
